import React from 'react'
import { Stack, Box, Text, AspectRatio } from '@chakra-ui/react';
import reelBackground from './data/assets/Main/reel-background.jpg'

const Reel = ({ text }) => {
  return (
        <Box>
            <Stack direction='column' bgImage={reelBackground} w='100%' minH={['100vh','100vh','90vh','100%']}  backgroundSize={['cover']} alignItems='center' justifyContent='center '>               
                <Stack direction='column' alignItems='center' mb={['20%','10%']} mt={['25%','15%']} textAlign={'center'}>
                  <Box h='100%' w={['90%','90%','85vw','853px']} pt={['30%', '30%', '0%', '0%']}>
                    <AspectRatio  ratio={16/9}>
                        <iframe
                            title='Pedro Serrano'
                            src='https://www.youtube.com/embed/FnkqD0fkZIg'
                            allowFullScreen
                        />
                     </AspectRatio>
                  </Box>
                    <Text fontSize='md' color='white' pt={['10%','2%']} fontWeight='300'>{text.subtitulo}</Text>
                </Stack>
            </Stack>
        </Box>
  )
}

export default Reel
